export const initialPreferences = {
  logo: "https://s3-ap-southeast-1.amazonaws.com/incart.cms/assets/images/logo.svg",
  font: {
    color: '#ffffff',
    family: [
      {
        label: "Agency",
        value: "agency"
      },
      {
        label: "Bebas",
        value: "bebas"
      },
      {
        label: "Arial",
        value: "Arial"
      }
    ]
  },
  background: {
    color: "#000000",
    image: "https://s3-ap-southeast-1.amazonaws.com/incart.cms/assets/images/background.jpg"
  }
}

export const initialTagBanner = {
  name: '',
  data: {
    deviceContent: {},
  }
}

export const initialElements = []
export const initialStoreTemplates = []

export const initialMenuState = {
  name: { en: '', th: '' },
  title: '',
  subtitle: '',
  url: '',
  target: '_self',
  image: '',
  imageLink: '',
  imageTarget: '_self',
};

export const initialColumn = {
  refElement: 'column',
  name: 'A Column',
  elements: [],
  defaultSettings: {},
}

export const initialSingleImage = {
  active: true,
  link: '',
  target: '_self',
  source: '',
}

export const initialImageCarousel = {
  defaultContent: {
    images: [initialSingleImage],
  },
  deviceContent: {
    desktop: {
      images: [initialSingleImage],
    },
    tablet: {
      images: [initialSingleImage],
    },
    mobile: {
      images: [initialSingleImage],
    }
  },
  defaultSettings: {
    showDots: true,
    swipe: true,
    fullWidth: true,
    centerMode: false,
  },
  deviceSettings: {
    desktop: {},
    tablet: {},
    mobile: {},
  }
}



// WEBPACK FOOTER //
// ./src/helpers/initialState.js